import { inject, Injectable, signal } from '@angular/core';

import { ENVIRONMENT } from '@core/common-legacy';
import { IntegrationKinds } from '@core/integrations-types';

@Injectable({ providedIn: 'root' })
export class ApplyWithWhatsappHelperService {
  private readonly environment = inject(ENVIRONMENT, { optional: true });

  public integrationCodeName = signal(this.getIntegrationCodeName());

  private getIntegrationCodeName() {
    const isRCEnvironment = this.environment?.environmentName === 'rc';
    return isRCEnvironment
      ? IntegrationKinds.WHATSAPP_HIRING_RCC
      : IntegrationKinds.WHATSAPP_HIRING_ADDON;
  }
}
